export function RouteLoading() {
  return (
    <main className="route-loading" aria-live="polite" aria-busy="true">
      <span className="route-loading__mark" aria-hidden="true">
        数
      </span>
      <p>正在打开课堂…</p>
    </main>
  );
}
